module.exports = __webpack_public_path__ + "public/StoreIcon/closeIcon.svg?9f0e2228";